export default __webpack_public_path__ + "static/sub-logo-chs-d7f97b7d0a473ed336cbb2bc39dc411d.png";